// extracted by mini-css-extract-plugin
export default {"pageTitleContainer":"page-title_pageTitleContainer__C3zsC","title":"page-title_title__7oJyq"};